module.exports = __webpack_public_path__ + "img/g0.b409811e.jpg";